<app-modal [open]="open()" [title]="title()" [closeOnBackdrop]="false" (closed)="cancelled.emit()">
  <div #dialogRoot role="dialog" aria-modal="true" [attr.aria-label]="title()">
    @if (message()) {
      <p class="mb-4 text-sm text-gray-700" data-testid="prompt-dialog-message">{{ message() }}</p>
    }
    <label class="flex flex-col gap-1 text-sm">
      <span class="font-medium text-gray-700">{{ label() }}</span>
      <textarea
        #field
        rows="4"
        class="w-full resize-y rounded-md border border-gray-300 px-3 py-2 text-base focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
        [placeholder]="placeholder()"
        [attr.maxlength]="maxLength()"
        [ngModel]="text()"
        (ngModelChange)="text.set($event)"
      ></textarea>
    </label>

    <div class="mt-6 flex justify-end gap-2">
      <app-button variant="secondary" [disabled]="submitting()" (clicked)="cancelled.emit()">
        {{ cancelLabel() }}
      </app-button>
      <app-button [disabled]="!canConfirm()" [loading]="submitting()" (clicked)="confirm()">
        {{ confirmLabel() }}
      </app-button>
    </div>
  </div>
</app-modal>
